import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const FeaturedProfiles = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const profiles = [
    {
      id: 1,
      name: "Vigneshkumar R",
      age: 25,
      profession: "Software Eng",
      location: "Coimbatore",
      porutham: "10/10",
      image: "/images/Frame 2147239550.png",
      verified: true
    },
    {
      id: 2,
      name: "Yazhini Raghavan",
      age: 24,
      profession: "Professor",
      location: "Trichy",
      porutham: "10/10",
      image: "/images/Frame 2147239567.png",
      verified: true
    }
  ];

  return (
    <section className="relative w-full py-16 sm:py-20 md:py-24 lg:py-28 overflow-hidden">
      {/* Background Text */}
      <div className="absolute top-0 left-0 right-0 pointer-events-none">
        <h2
          className="text-[150px] sm:text-[300px] md:text-[500px] lg:text-[952px] font-['BD_Megalona_DEMO_Personal_Use_Only'] italic lowercase text-[#ffefef]/60 leading-none home-bg-text-lineheight"
        >
          matches
        </h2>
      </div>
      <div className="relative w-full max-w-[1360px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="mb-12 sm:mb-16 md:mb-20">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-wide bg-gradient-to-r from-[#8a216b] to-[#f03f16] bg-clip-text text-transparent mb-3 sm:mb-4">
            matches for you
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[48px] font-semibold text-text-primary capitalize mb-4 sm:mb-5 md:mb-6">
            Featured Active Profiles
          </h2>
          <p className="text-base sm:text-lg text-text-primary/60 max-w-2xl">
            Explore genuine, active, and verified Anuppagoundar bride and groom profiles to find your perfect life partner.
          </p>
        </div>

        {/* Profiles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {profiles?.map((profile) => (
            <ProfileCard key={profile?.id} profile={profile} navigate={navigate} isAuthenticated={isAuthenticated} />
          ))}

          {/* CTA Card - Full height container preventing image squishing on mobile */}
          <div
            className="relative w-full min-h-[380px] sm:min-h-[440px] rounded-[36px] p-6 sm:p-8 flex flex-col justify-end items-center overflow-hidden border border-primary-brand/40 shadow-lg bg-cover bg-center"
            style={{
              backgroundImage: "url('/images/step-card-1.webp')",
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            {/* Subtle Overlay Gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />

            <button
              type="button"
              className="relative z-10 w-full bg-gradient-to-r from-[#8a216b] to-[#f03f16] text-white py-2.5 px-6 rounded-full text-base sm:text-lg font-bold flex items-center justify-center gap-2 shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer"
              onClick={() => navigate('/matrimony/signup')}
            >
              <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
              <span>Create Free Profile</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const ProfileCard = ({ profile, navigate, isAuthenticated }) => (
  <div className="bg-gradient-to-b from-[#fff7f8] to-white border border-primary-brand/40 rounded-[36px] p-4 sm:p-5 md:p-6 shadow-sm hover:shadow-md transition-shadow">
    {/* Profile Image */}
    <div className="relative mb-4 sm:mb-5">
      <div className="relative rounded-3xl overflow-hidden bg-gray-200 h-[180px] sm:h-[200px]">
        <img
          src={profile?.image}
          alt={profile?.name}
          className="w-full h-full object-cover"
        />
        {!isAuthenticated && (
          <div className="absolute inset-0 bg-white/5 backdrop-blur-sm flex items-center justify-center">
            <img
              src="/images/vector.png"
              alt="Lock"
              className="w-12 sm:w-14 md:w-16 h-auto"
            />
          </div>
        )}
      </div>
    </div>

    <div className="h-[1px] bg-background-neutral mb-4 sm:mb-5"></div>

    {/* Verified Badge */}
    {profile?.verified && (
      <div className="inline-flex items-center gap-1.5 bg-emerald-600 px-3 py-1 rounded-full shadow-sm mb-3 sm:mb-4">
        <svg className="w-4 h-4 text-white fill-current flex-shrink-0" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
        <span className="text-white text-xs sm:text-sm font-semibold">Verified</span>
      </div>
    )}

    {/* Name */}
    <h3 className="text-2xl sm:text-3xl md:text-[28px] font-semibold text-text-dark mb-4 sm:mb-5 md:mb-6">
      {profile?.name}
    </h3>

    {/* Details Grid */}
    <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
      <div className="grid grid-cols-2 gap-4">
        <DetailItem label="AGE" value={profile?.age ? `${profile.age} Yrs` : ''} />
        <DetailItem label="PORUTHAM" value={profile?.porutham} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <DetailItem label="PROFESSION" value={profile?.profession} />
        <DetailItem label="LOCATION" value={profile?.location} />
      </div>
    </div>

    {/* Action Buttons */}
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
      <button
        type="button"
        className="flex-1 bg-gradient-to-r from-[#8a216b] to-[#f03f16] text-white text-base sm:text-lg font-bold py-2.5 px-6 rounded-full shadow-md hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-2 cursor-pointer"
        onClick={() => navigate(isAuthenticated ? '/matrimony/search' : '/matrimony/login')}
      >
        <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
        </svg>
        <span>Unlock</span>
      </button>

      <button
        type="button"
        className="group flex-1 btn-brand-outline text-base sm:text-lg font-semibold py-2.5 px-6 rounded-full shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer"
        onClick={() => navigate(isAuthenticated ? '/matrimony/search' : '/matrimony/login')}
      >
        <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
          <defs>
            <linearGradient id={`interestGrad-${profile?.id}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8a216b" />
              <stop offset="100%" stopColor="#f03f16" />
            </linearGradient>
          </defs>
          <path className="group-hover:fill-white transition-colors" fill={`url(#interestGrad-${profile?.id})`} d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
        <span className="brand-gradient-text">Interest</span>
      </button>
    </div>
  </div>
);

const DetailItem = ({ label, value }) => (
  <div>
    <p className="text-xs sm:text-sm text-text-tertiary uppercase mb-1 sm:mb-2">{label}</p>
    <p className="text-lg sm:text-xl font-semibold text-text-dark capitalize">{value}</p>
  </div>
);

export default FeaturedProfiles;